export default "/assets/website/components/images/blabloom-logo-mobile.fa2e2940.svg";